
import React from 'react';
import ReceiptsPreview from './ReceiptsPreview';

const Receipts = () => {    
    
    return(
        <div className="container">
           <ReceiptsPreview />
        </div>
    )
    
}

export default Receipts;
